import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { api_get, api_post } from "api/utils"


export type BioType = {
    key: string;
    identity: string;
    one_liner: string;
    about: string;
    about_ct: string;
};

type BioContextType = {
    items: BioType[];
    getBio: (identityUuid: string) => BioType | null;
    fetchBio: (identityUuid: string) => Promise<BioType>;
    updateField: (identityUuid: string, field: string, value: string) => Promise<BioType>;
}

export const BioContext = React.createContext<BioContextType>({
    items: [] as BioType[],
    getBio: () => { throw 'Not implemented' },
    fetchBio: () => { throw 'Not implemented' },
    updateField: () => { throw 'Not implemented' }
});

export const BioProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [items, addBio] = useState([] as BioType[]);

    const getBio = (identityUuid: string) => {
        return items.find((item) => item.identity === identityUuid) || null;
    };

    const fetchBio = async (identityUuid: string) => {
        const response = await api_get(`/bio/by-identity?identity=${identityUuid}`);
        const data = await response.json();
        addBio([...items, data]);
        return data;
    };

    const updateField = async (identityUuid: string, field: string, value: string) => {
        const data = { identity: identityUuid, field: field, value: value }
        const response = await api_post('/bio/update-field', data);
        const bio = await response.json();
        addBio([...items, bio]);
        return bio;
    };

    const data = {
        items,
        fetchBio,
        getBio,
        updateField
    };

    return (
        <BioContext.Provider value={data}>{ children }</BioContext.Provider>
    );

});
